import store from 'store'
import { goDocumentsSubSection } from 'actions/client/routing'
import { redirect } from 'redux-first-router'
import { OE_PROSPECT }  from 'utils/Client/userTypes'
import {
  isOnlineExperienceProspectRoute,
} from 'routing/routes'

export const isRouteAllowed = (onlineExperienceType, type, payload) => {
  const isProspectExperience = onlineExperienceType === OE_PROSPECT
  return !isProspectExperience || isOnlineExperienceProspectRoute(type, payload)
}

export const redirectIfUnauthorized = async (onlineExperienceType, type, payload) => {
  const routeIsAllowed = isRouteAllowed(onlineExperienceType, type, payload)

  if (!routeIsAllowed) {
    store.dispatch(redirect(goDocumentsSubSection('my-uploads')))
  }
  return routeIsAllowed
}

export default {
  redirectIfUnauthorized,
  isRouteAllowed,
}



// WEBPACK FOOTER //
// ./src/utils/Client/authorization.js